<template>

    <Head :title="title"></Head>

    <main class="min-h-screen w-screen flex flex-col bg-grey-light relative">

        <LanguageSelector class="absolute top-4 right-4 z-40" />


        <div class="flex flex-col items-center h-full mx-auto px-2 xl:px-0"
            style="max-width: 1280px;">

            <Logo class="flex m-auto w-32 mt-20 mb-10"/>

            <slot></slot>

        </div>

    </main>

</template>


<script>

import {defineComponent} from "vue";
import {Head} from '@inertiajs/inertia-vue3';
import Logo from '@/Components/Logo.vue';
import LanguageSelector from "@/Components/LanguageSelector";

export default defineComponent({

    props: {
        title: String,
    },

    components: {
        Logo,
        Head,
        LanguageSelector
    },


    mounted() {

        this.init_one_signal();

    },

})


</script>


<style scoped>

</style>
